var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"reportRef",style:({ height: `${_vm.innerHeight}px` }),attrs:{"id":"reportContainer"}},[_vm._v(" Loading the report... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }